export default "__VITE_ASSET__B3s5xC$W__"